<template>
    <!-- 전체 콘텐츠 영역 -->
      <div class="main-contents">
        <div class="news_wrap">
          <div class="path">
            <a class="pa-3" style="background-color: red; color: white;">S A M P L E</a>
            <span class="ml-5" style="font-family: Pretendard-Medium; font-size: 18px;">&#8251; 하단의 이미지 등록 기능을 이용했을 경우, 해당 이미지는 <span style="font-weight: bold">내용 저장 후</span> 미리 보기 가능</span>
          </div>

          <!-- view -->
          <div class="news-view">
            <div class="view-title">{{previewInfo.previewTitle}}</div>
            <div class="attatched-image ta-left" v-if="previewInfo.attaFileSeq">
              <ImageComp :src="'/api/main/bbs/newsCenterImage?attaFileSeq='+previewInfo.attaFileSeq" alt="공지사항 이미지"/>
            </div>
            <div class="ql-snow">
                <div class="view-text ql-editor">
                    <div v-html="previewInfo.previewCont"></div>
                </div>
            </div>
          </div>
          
        </div>
      </div>
</template>

<script>

// Quill 에디터 스타일 임포트
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill-emoji/dist/quill-emoji.css";

export default {
    data () {
        return {
            previewInfo : {
                attaFileSeq : '',
                previewTitle : '',
                previewCont : '',
            }
        }
    },

    beforeMount() {
        var previewData = sessionStorage.getItem('newsPreviewData');

        if (previewData) {
            this.previewInfo = JSON.parse(previewData);
            // sessionStorage 삭제
            sessionStorage.removeItem('newsPreviewData');
        }
    },
}
</script>
